import { ICar } from 'types';

export const getBackgroundImageUri = (car: ICar): string => {
  const carBrand = car.brand_name?.replace(' ', '_')?.toLowerCase();
  const carModel = car.model_name?.replace(' ', '_')?.toLowerCase();
  const carColor = car.color?.toLowerCase();

  if (!carModel || !carColor) {
    return '/images/cars/model_unknown.png';
  }

  if (carBrand === 'rivian') {
    return `/images/cars/${carBrand}_${carModel}.png`;
  }

  if (carBrand === 'lucid') {
    return `/images/cars/${carBrand}_${carModel}.webp`;
  }

  const backgroundImageURI = `/images/cars/${carBrand}_${carModel}_${carColor}.png`;

  return backgroundImageURI;
};
